import { render, staticRenderFns } from "./BranchLoyaltyConfig.vue?vue&type=template&id=f615659e&scoped=true"
import script from "./BranchLoyaltyConfig.vue?vue&type=script&lang=js"
export * from "./BranchLoyaltyConfig.vue?vue&type=script&lang=js"
import style0 from "./BranchLoyaltyConfig.vue?vue&type=style&index=0&id=f615659e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f615659e",
  null
  
)

export default component.exports